import styled from 'styled-components';

export const ChartItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 16px;
	border: 1px solid ${({ theme }) => theme.colors.grey4};
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.2s ease;
	background-color: ${({ theme }) => theme.colors.white};
	min-height: 200px;
	position: relative;

	&:hover {
		border-color: ${({ theme }) => theme.colors.blue};
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	&.selected {
		border-color: ${({ theme }) => theme.colors.punchupOrange};
		border-width: 2px;
		box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.punchupOrange}33;
		transform: translateY(-2px);
	}

	/* Locked (e.g. tickets already sold): non-selected charts are greyed out and inert. */
	&.disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}

	&.disabled:hover {
		border-color: ${({ theme }) => theme.colors.grey4};
		box-shadow: none;
	}
`;

export const ChartThumbnail = styled.img`
	width: 100%;
	max-width: 150px;
	height: 100px;
	object-fit: cover;
	border-radius: 4px;
	margin-bottom: 12px;
	border: 1px solid ${({ theme }) => theme.colors.grey6};
`;

export const ChartName = styled.h3`
	font-size: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.black2};
	text-align: center;
	margin: 0;
	line-height: 1.4;
	word-break: break-word;
`;

export const ChartStatus = styled.span`
	font-size: 12px;
	color: ${({ theme }) => theme.colors.grey};
	margin-top: 4px;
	text-transform: capitalize;

	&.published {
		color: ${({ theme }) => theme.colors.green};
	}

	&.not-used {
		color: ${({ theme }) => theme.colors.grey};
	}
`;

export const ChartsListContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	gap: 16px;
	width: 100%;
	margin: 16px 0;
`;

export const ChartsSection = styled.div`
	width: 100%;
	margin-top: 24px;
`;

/* Matches the Punchup form-label typography (.punchupFormLabel) so the seat-chart
 * label is consistent with every other field label in the green-zone forms. */
export const ChartsSectionTitle = styled.h2`
	font-family: var(--punchup-font-family, Inter, sans-serif);
	font-size: var(--punchup-font-size-sm, 14px);
	font-weight: 500;
	color: var(--punchup-color-text, #000);
	margin: 0 0 var(--punchup-space-1, 4px) 0;
`;

/* Mirrors .punchupFormDescription — muted sub-label under the title. */
export const ChartsSectionDescription = styled.p`
	font-family: var(--punchup-font-family, Inter, sans-serif);
	font-size: var(--punchup-font-size-xs, 12px);
	color: var(--punchup-color-text-muted, #9a9a9a);
	margin: 0 0 var(--punchup-space-4, 16px) 0;
`;

export const LoadingState = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 200px;
	color: ${({ theme }) => theme.colors.grey};
	font-size: 16px;
`;

export const ErrorState = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 200px;
	color: ${({ theme }) => theme.colors.red};
	font-size: 16px;
	text-align: center;
`;

export const SelectedIndicator = styled.div`
	position: absolute;
	top: 8px;
	right: 8px;
	width: 24px;
	height: 24px;
	background-color: ${({ theme }) => theme.colors.punchupOrange};
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;
